import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import Skeleton from 'personalization-lib/components/shared/display/Skeleton';
import PublishStatus from 'personalization-lib/components/assetDetails/PublishStatus';
import TargetingInfo from 'personalization-lib/components/targeting/TargetingInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssetInfo = ({
  segmentIdentifier,
  targetingState,
  publishStatus,
  error,
  loading
}) => {
  if (loading) {
    return /*#__PURE__*/_jsx(Skeleton, {
      inlineSize: "20ch",
      blockSize: "1em",
      as: "span"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(Text, {
      as: "span",
      color: "text-alert-default",
      "data-test-id": "variant-info-error",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "personalizationLib.variantInfo.error"
      })
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    typography: "detail-100",
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      as: "span",
      children: [/*#__PURE__*/_jsx(PublishStatus, {
        status: publishStatus
      }), "|", /*#__PURE__*/_jsx(TargetingInfo, {
        segmentIdentifier: segmentIdentifier,
        targetingState: targetingState
      })]
    })
  });
};
export default AssetInfo;